<script>
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'FormCard',
    props: {
        // Renders the sections and their dividers without the card chrome, so that a group of
        // sections coming from a child component joins the surrounding card instead of opening
        // a second one.
        bare: {
            type: Boolean,
            default: false,
        },
    },
    render(h) {
        // Sections are conditionally rendered, so skip the card entirely when none of them are
        // present. Otherwise an empty card (background, border, shadow) would still be painted.
        const sections = (this.$slots.default || []).filter((vnode) => vnode.tag !== undefined);

        if (!sections.length) return undefined;

        const divider = 'divide-y divide-neutral-300';

        return h('div', { class: this.bare ? divider : `bg-white rounded shadow ${divider}` }, sections);
    },
});
</script>
